import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './tailwind.css';
import './i18n';
import { NetworkErrorProvider } from './hooks/context/NetworkErrorContext';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true, // 👈 Resolves your latest warning
      }}
    >
      <NetworkErrorProvider>
        <App />
      </NetworkErrorProvider>
    </BrowserRouter>
  </React.StrictMode>
);

